<app-breadcrumb [pageFlags]="pageFlags"></app-breadcrumb>
<div class="offer-detail-v2-wrapper" *ngIf="coupon">
    <!-- <offer-detail-al-v1 [offer]="coupon" [configObj]="configObj"></offer-detail-al-v1> -->

    <app-offer-detail-card [offer]="coupon" [logoProps]="logoProps" (onGetOffer)="onGetOffer($event)" [isUserLoggedIn]="isUserLoggedIn"></app-offer-detail-card>


    <div>
      <div class="simple-page-title section">
        <div class="title-bg clearfix">
          <h2 role="heading" aria-level="2" class="simple-page-title-text display-4" tabindex="-1" data-qa="smpl-pg-ttl">Qualifying Product(s)</h2>
        </div>
      </div>

    <offer-qualified-products-al-v1
        data-infinite-scroll-type="client"
        data-driven="catalog"
        data-load-type="loadmore"
        data-sorts="price-low-high,search-rank,most-popular"
        data-default-sorts="most-popular"
        data-api-type="c-products-by-upc"
        [attr.data-api-url]="catalogApiUrl"
        [dataValue] ="dataValue"
        [configObj]="configObj">
    </offer-qualified-products-al-v1>

    <ng-container *ngIf="!isOfferDetailsDispBannerDisabled && categoryName">
      <div class="mt-3">
        <banner-unit-v1 [bannerPositionName]="'midb1'" [categoryName]="categoryName"></banner-unit-v1>
      </div>
    </ng-container>
    </div>

</div>
